import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The standalone files page is gone — home shows the folder strip and the full
 * library. The route stays as a redirect so old bookmarks and deep links keep
 * working instead of hitting the 404 boundary.
 */
export const Route = createFileRoute('/app/_authenticated/_dashboard/files/')({
  beforeLoad: () => {
    throw redirect({ to: '/app/home', replace: true });
  },
});
